module.exports = __webpack_public_path__ + "img/lachsbowlfront.f810ed2e.png";